(function () {
  if (window.ccAddToCartBound) return;
  window.ccAddToCartBound = true;

  const RESET_MS = 1800;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
    document.dispatchEvent(new CustomEvent('cc:cart:updated', { detail: { count } }));
  }

  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && typeof data.item_count === 'number') updateCartCount(data.item_count);
      })
      .catch(() => {});
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cc-add-to-cart]');
    if (!button) return;
    if (button.classList.contains('is-loading')) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.classList.remove('is-added', 'is-error');
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        button.classList.remove('is-loading');
        if (!ok) throw new Error((data && data.description) || 'Add to cart failed');
        button.classList.add('is-added');
        refreshCount();
        document.dispatchEvent(new CustomEvent('cc:cart:updated'));
        setTimeout(() => button.classList.remove('is-added'), RESET_MS);
      })
      .catch(() => {
        button.classList.remove('is-loading');
        button.classList.add('is-error');
        setTimeout(() => button.classList.remove('is-error'), RESET_MS);
      });
  });
})();
